module.exports = "<label>{{ progreso }}%</label>\r\n<div class=\"progress\">\r\n  <div \r\n    class=\"progress-bar\" \r\n    role=\"progressbar\" \r\n    aria-valuemin=\"0\" \r\n    aria-valuemax=\"100\" \r\n    [ngStyle]=\"{'width.%': progreso}\">\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/progressBar/progressbar.component.html
// module id = ../../../../../src/app/helpers/components/progressBar/progressbar.component.html
// module chunks = main